"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ChannelsList", {
  enumerable: true,
  get: function get() {
    return _ChannelsList.ChannelsList;
  }
});
var _ChannelsList = require("./ChannelsList");